import React, { useEffect, useState } from "react";
import jci from "../../../../public/assets/images/updated_jci.png";
import united from "../../../images/jci.png";
import united_health from "../../../images/jci.png";
import { IMAGE_URL } from "../../../constants";
import { thirdparty } from "../../..";
import { FaRegPlayCircle } from "react-icons/fa";

const NewJciComponent = () => {
  const [fatchdata, setFatchdata] = useState([]);

  useEffect(() => {
    fetchData(); // Initial data fetch
  }, []);
  const fetchData = async () => {
    try {
      const response = await thirdparty.get("/settings/2"); // Update the API endpoint

      if (response.status === 200) {
        setFatchdata(response.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  return (
    <div>
      <section
        style={{ backgroundColor: "#F7F5EF" }}
        className="news-events pt-0 pb-0"
        id="hr-lines"
      >
        <div
        className="pb-3"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
            marginBottom: "10px",
          }}
        >
          <h3
            className="text-left"
            style={{
              color: "#af9763",
              fontSize: "30px",
              fontWeight: "600",
              textAlign: "center",
              width: "100%",
            }}
          >
            News
          </h3>
          {/* <img src="/assets/images/department_under.png" alt="" /> */}
        </div>
        {/* laptop and pc section */}
        <div
          style={{ position: "relative" }}
          className="container d-none mt-5 py-2 d-lg-flex justify-content-between align-items-center justify-content-between gap-1"
        >
          <div
            class=""
            style={{
              position: "absolute",
              left: "49.5%",
              top: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <img
              className="img-fluid"
              src="/assets/images/jci_updated_circular.png"
              alt=""
              srcset=""
            />
          </div>
          <div className="w-50 jci-left-container">
            <div
              className="h-100 d-flex flex-column justify-content-center ps-5 align-items-start gap-3"
              style={{
                borderRadius: "20px",
                backgroundImage: "url(/assets/images/jci_left_shape_1.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div
                style={{ width: "90%" }}
                className="d-flex justify-content-between align-items-center"
              >
                <div className="d-flex jsutify-content-center align-items-center w-50 gap-3">
                  <img
                    className="jci-brand-img"
                    // style={{ maxWidth: "78px" }}
                    src="/assets/images/united_logo.png"
                    alt=""
                    srcset=""
                  />
                  <img
                    className="jci-brand-img"
                    // style={{ maxWidth: "78px" }}
                    src="/assets/images/united_logo_health.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div>
                  <div
                    style={{
                      height: "40px",
                      width: "150px",
                      backgroundColor: "#AF9763",
                      borderRadius: "5px",
                    }}
                    className="d-flex justify-content-around align-items-center"
                  >
                    <img src="/assets/images/calendar-header.png" alt="" />
                    <h6 className="mb-0 text-white">03, Mar 2023</h6>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-start align-items-center w-75">
                <a
                  href="https://www.dhakatribune.com/business/323389/united-hospital-attains-jci-accreditation"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className=""
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      // maxWidth: "300px",
                      // width: "100%",
                    }}
                  >
                    <div className="mb-3">
                      <img
                        style={{ borderRadius: "5px" }}
                        className="jci-img-news"
                        src="/assets/images/jci_img.jpg"
                        alt=""
                      />
                    </div>
                    <div className="d-flex flex-column gap-1">
                      <p className="jci-heading fw-normal">
                        United Hospital attains JCI accreditation
                      </p>
                      <p className="mb-2">
                        A remarkable feat in healthcare excellence
                      </p>
                      <span
                        style={{
                          maxWidth: "130px",
                          backgroundColor: "#AF9763",
                          padding: "8px 15px",
                          color: "#ffffff",
                          borderRadius: "5px",
                          textAlign: "center",
                        }}
                      >
                        Read More
                      </span>
                    </div>

                    <div className="">
                      {/* <h2>United Hospital attains JCI accreditation</h2> */}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div
            className="w-50 jci-right-container d-flex justify-content-center align-items-center"
            style={{
              backgroundImage: "url(/assets/images/jci_top_video_img_update.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: "10px",
            }}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                height: "80px",
                width: "80px",
                borderRadius: "50%",
                backgroundColor: "#3c3c3c8f",
              }}
            >
              <FaRegPlayCircle
                className="play-icon"
                style={{
                  color: "#F58220",
                  fontSize: "60px",
                  cursor: "pointer",
                }}
                data-bs-toggle="modal"
                data-bs-target="#videoModal"
              />
            </div>
          </div>
        </div>

        {/* mobile and tablet section */}
        <div
          style={{ position: "relative" }}
          className="container d-flex py-2 d-lg-none flex-column align-items-center justify-content-between gap-1"
        >
          <div
            class=""
            style={{
              position: "absolute",
              left: "49.5%",
              top: "47%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <img
              // style={{ maxWidth: "160px" }}
              className="jci_circular_img"
              src="/assets/images/jci_updated_circular.png"
              alt=""
              srcset=""
            />
          </div>
          <div
            className="w-100 jci-right-container d-flex justify-content-center align-items-center"
            style={{
              backgroundImage: "url(/assets/images/jci_top_video_img_mobile_top.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: "10px",
            }}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                height: "80px",
                width: "80px",
                borderRadius: "50%",
                backgroundColor: "#3c3c3c8f",
              }}
            >
              <FaRegPlayCircle
                className="play-icon"
                style={{
                  color: "#F58220",
                  fontSize: "60px",
                  cursor: "pointer",
                }}
                data-bs-toggle="modal"
                data-bs-target="#videoModal"
              />
            </div>
          </div>
          <div className="jci-left-container">
            <div
              className="h-100 d-flex flex-column  justify-content-around  align-items-start gap-3 gap-md-5 pb-2 pb-sm-0"
              style={{
                borderRadius: "20px",
                backgroundImage:
                  "url(/assets/images/jci_bottom_section_img_1.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="w-100 mt-2 px-2 px-md-5 d-flex justify-content-between align-items-center give-padding">
                <div className="d-flex justify-content-start gap-1 align-items-center w-50 gap-3">
                  <img
                    className="jci-brand-img"
                    // style={{ maxWidth: "78px" }}
                    src="/assets/images/united_logo.png"
                    alt=""
                    srcset=""
                  />
                  <img
                    className="jci-brand-img"
                    // style={{ maxWidth: "78px" }}
                    src="/assets/images/united_logo_health.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div>
                  <div
                    style={
                      {
                        // height: "20px",
                        // width: "100px",
                        // backgroundColor: "#AF9763",
                        // borderRadius: "5px",
                      }
                    }
                    className="d-flex justify-content-around align-items-center date-container"
                  >
                    <img
                      className="calendar-img"
                      src="/assets/images/calendar-header.png"
                      alt=""
                    />
                    <h6 className="mb-0 text-white">03, Mar 2023</h6>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-start align-items-center w-100 px-2 px-md-5">
                <a
                  href="https://www.dhakatribune.com/business/323389/united-hospital-attains-jci-accreditation"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-sm-3"
                    style={
                      {
                        // display: "flex",
                        // flexDirection: "column",
                        // justifyContent: "space-between",
                        // alignItems: "flex-start",
                        // maxWidth: "300px",
                        // width: "100%",
                      }
                    }
                  >
                    <div className="mb-1">
                      <img
                        style={{ borderRadius: "5px" }}
                        className="jci-img-news"
                        src="/assets/images/jci_img.jpg"
                        alt=""
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-between gap-sm-3">
                      <p className="jci-heading fw-normal">
                        United Hospital attains JCI accreditation
                      </p>
                      <p className="mb-2 jci-text">
                        A remarkable feat in healthcare excellence
                      </p>
                      <div className="">
                        <span
                          className="read-more-text"
                          style={
                            {
                              // maxWidth: "90px",
                              // backgroundColor: "#AF9763",
                              // padding: "4px 10px",
                              // color: "#ffffff",
                              // borderRadius: "5px",
                              // textAlign: "center",
                              // fontSize: "10px",
                            }
                          }
                        >
                          Read More
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* modal section */}
        <div
          class="modal fade"
          id="videoModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                  dangerouslySetInnerHTML={{ __html: fatchdata.value }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewJciComponent;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/NewJciComponent.js